import i18next from 'i18next';
import sanitizeHtml from 'sanitize-html';
import ShowdownService from 'showdown';

const showdownService = new ShowdownService.Converter({
  openLinksInNewWindow: true,
  simpleLineBreaks: true,
});

// Helper function to convert raw URLs to clickable links
const linkifyRawUrls = (text: string) => {
  const urlRegex = /(^|[^\\[(])\b(https?:\/\/[\w\-\.]+(:\d+)?(\/[^\s]*)?)(?![\])])/g;
  return text.replace(urlRegex, (_match, prefix, url) => {
    // Skip URLs already part of a CommonMark link
    return `${prefix}[${i18next.t('link', { ns: 'common' })}](${url})`;
  });
};

export const asHtml = (raw?: string) => {
  if (!raw) return '';
  // Convert raw links to markdown links before passing to showdown
  const linkified = linkifyRawUrls(raw);
  return showdownService.makeHtml(sanitizeHtml(linkified || ''));
};
